<div class="ui-g-12">

  <div class="ui-g">
    <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
      <app-infobox [pointData]="indicator.pointData" [penetration]="indicator.penetration" [t]="indicator.t" [options]="indicator.options"></app-infobox>
    </div>
  </div>

  <div class="campaigncharts" *ngIf="data != null">
    <div class="ui-g">
      <div class="ui-g-12 ui-md-6 ui-sm-12">
        <h2>{{ translations.fatturato }}</h2>
        <div class="chart-container">
          <chart [options]="fatturatoChart.options"
                 (load)="setChartInstance(fatturatoChart, $event.context)"></chart>
        </div>
      </div>

      <div class="ui-g-12 ui-md-6 ui-sm-12">
        <h2>{{ translations.penetrazioneCarta }}</h2>
        <div class="chart-container">
          <chart [options]="penetrazioneCartaChart.options"
                 (load)="setChartInstance(penetrazioneCartaChart, $event.context)"></chart>
        </div>
      </div>
    </div>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/overview/overview-loyalty/overview-loyalty-value/overview-loyalty-value.component.html